import React from 'react';
import PropTypes from 'prop-types';
import { useTranslator } from '../../../../components/i18n/useTranslator';

// Components
import StyledButton from '../../../../components/buttons/StyledButton';

const PromoBonus50SuccessContent = ({ action }) => {
    const translate = useTranslator('modal', 'user.bonusCards.success');

    return (
        <div className="modal-child-content">
            <img style={{ width: '32rem', height: '22.5rem' }} src={require('./promo-claim-success.png')} />

            <div className="center-body">
                <h1>{translate('title', 'Bonus cards claimed!')}</h1>

                <p className="heavy">{translate('description', 'You can now add an extra 50 cards to Milanote')}</p>

                <StyledButton className="primary" onClick={action}>
                    {translate('continueButton', 'Continue')}
                </StyledButton>
            </div>
        </div>
    );
};

PromoBonus50SuccessContent.propTypes = {
    action: PropTypes.func,
};

export default PromoBonus50SuccessContent;
